<div class="calcitems" #calcitems [style.overflow]="isMobileView ? 'hidden' : 'auto'">
   <ng-container *ngFor="let item of items.controls; index as index; last as last">
      <calculator-item
         *ngIf="!isMobileView || (isMobileView && index == carouselIndex)"
         [index]="index" [last]="last"
         [calcForm]="item"
         (remove)="removeCalcItem(index)"
         (dirty)="addCalcItem()">
      </calculator-item>
   </ng-container>
</div>

<ng-container *ngIf="isMobileView">
   <div class="carousel" *ngIf="items.length">
      <button id="previousButton" mat-button (click)="moveCalc(-1)" [disabled]="items.length < 2">
         <mat-icon id="previousButtonIcon">chevron_left</mat-icon>
      </button>
      <span id="calculatorItemPage">Item {{carouselIndex + 1}} of {{items.length}}</span>
      <button id="nextButton" mat-button (click)="moveCalc(1)" [disabled]="items.length < 2">
         <mat-icon id="nextButtonIcon">chevron_right</mat-icon>
      </button>
   </div>

   <button id="addItemButton" mat-stroked-button color="primary" class="add-calc" (click)="addCalcItem()" [disabled]="items.length >= 100">
      <mat-icon id="addItemIcon">add</mat-icon> ADD ANOTHER ITEM
   </button>
</ng-container>
